











































































































































































































































































































































































































































































































































































































































































































































































































































































































































import store from "../store";
import { inputs, printPage } from "../mixins/mixins";
import Scenario from '../components/Scenario.vue';
const pastureData = require("../data/pasture-data.json");

export default {
  mixins: [inputs, printPage],
  components: { Scenario },

  data() {
    return {
      title: "Step 3",
      ss: store.state,
      panels: [0, 1, 2, 3]
    };
  },

  watch: {
    // Update fertiliser rates on change
    kg_P_DSE: function(this: any) {
      store.state.step3.fertiliserRate = this.fertiliser(this.averageAnnual);
      store.state.step3.maintenanceFertiliserRate = parseFloat(
        this.fertiliser(
          this.maintenanceP(
            store.state.step2.type === "stockingRate"
              ? store.state.step2.target
              : store.state.step2.stockingRateTarget
          )
        ).toFixed(2)
      );
    }
  },

  computed: {
    // Calculate P/DSE based on values stored in /data/pasture-data.json

    // Filter data to either "poorPasture" or "improvedPasture" based on pasture type selection
    kg_P_DSE: function(this: any): number {
      let index = this.getPastureDataIndex();
      let data = null;

      // Poor or Improved Pasture Data
      if (store.state.step3.pasture === "Native") {
        data = pastureData.poorPasture;
      } else {
        data = pastureData.improvedPasture;
      }

      // Calculate predicted value

      // y = (m * x) + c
      // m = y2 - y1 / x2 - x1
      // c = y - mx

      let y = 0;
      let m = (data[index]["800"] - data[index]["400"]) / (800 - 400);
      let x = store.state.step3.rainfall;
      let c = data[index]["800"] - m * 800;
      y = m * x + c;

      let predicted = Math.round(y * 100) / 100;
      store.state.step3.DSE = predicted;
      return predicted;
    },

    // Calculate stocking rate in first year of plan
    stockingRateYr1: function(): number {
      let target =
        store.state.step2.type === "stockingRate"
          ? store.state.step2.target
          : store.state.step2.stockingRateTarget;
      let currentStockingRate = parseFloat(
        store.state.step2.stockingRateCurrent
      );
      // Prevent divide by 0 error
      if (store.state.step3.years > 0) {
        return (
          currentStockingRate +
          (target - currentStockingRate) / store.state.step3.years
        );
      }
      return 0;
    },

    // Calculate the planed increase in P / Additional P required
    plannedIncreaseInP: function(): number {
      let potential = store.state.step1.value;
      let target =
        store.state.step2.type === "stockingRate"
          ? store.state.step2.fertilityTarget
          : store.state.step2.target;
      // Prevent divide by 0 error
      if (store.state.step3.years > 0) {
        return (target - potential) / store.state.step3.years;
      }
      return 0;
    },

    // Calculate the raise in P  based on values stored in /data/pasture-data.json -> "raiseInP"
    raiseInP: function(): number {
      // Colwell or Olsen data
      let data = null;
      if (store.state.step1.type === "Colwell") {
        data = pastureData.raiseInP.colwell;
      } else {
        data = pastureData.raiseInP.olsen;
      }

      // Linear Regression Formula

      // y = a + bx + ∈
      // y – is the dependent variable
      // x – is the independent (explanatory) variable
      // a – is the intercept
      // b – is the slope
      // ∈ – sum of

      // a = (Σy)(Σx2) - (Σx)(Σxy) / n * (Σx^2) - (Σx)^2
      // b = n * (Σxy) - (Σx)(Σy) / n * (Σx^2) - (Σx)^2

      let xValues = [50, 100, 200, 300, 400, 500, 600];
      let yValues = [];
      let xyValues = [];
      let xSqrValues = [];
      for (let i = 0; i < xValues.length; i++) {
        yValues.push(data[xValues[i].toString()]);
        xyValues.push(xValues[i] * yValues[i]);
        xSqrValues.push(xValues[i] * xValues[i]);
      }

      let n = xValues.length;
      let sumX = xValues.reduce((a: number, b: number) => a + b, 0);
      let sumY = yValues.reduce((a: number, b: number) => a + b, 0);
      let sumXY = xyValues.reduce((a: number, b: number) => a + b, 0);
      let sumXSqr = xSqrValues.reduce((a: number, b: number) => a + b, 0);

      let aIntercept =
        (sumY * sumXSqr - sumX * sumXY) / (n * sumXSqr - Math.pow(sumX, 2));
      let bSlope =
        (n * sumXY - sumX * sumY) / (n * sumXSqr - Math.pow(sumX, 2));

      let y = aIntercept + bSlope * store.state.step1.pbi;
      y = Math.round(y * 100) / 100;
      return y;
    },

    // Calculate the extra P required per year
    extraPRequired: function(this: any): number {
      return this.plannedIncreaseInP * this.raiseInP;
    },

    // Calculate the average annual application
    averageAnnual: function(this: any): number {
      let target =
        store.state.step2.type === "stockingRate"
          ? store.state.step2.target
          : store.state.step2.stockingRateTarget;
      let yr1 =
        this.maintenanceP(this.stockingRateYr1) +
        parseFloat(this.extraPRequired);
      let yrX = this.maintenanceP(target) + parseFloat(this.extraPRequired);
      let annualPAvg = (yr1 + yrX) / 2;
      let annualFertiliser = this.fertiliser(annualPAvg);
      return Math.max(0, annualPAvg);
    },

    // Returns fertiliser rate needed to increase P fertility
    fertiliserRate: function(this: any): number {
      let rate = parseInt(this.fertiliser(this.averageAnnual));
      store.state.step3.fertiliserRate = rate;
      return Math.max(0, rate);
    },

    // Returns fertiliser rate needed to maintain P fertility
    maintenanceFertiliserRate: function(this: any): number {
      let rate = this.fertiliser(
        this.maintenanceP(
          store.state.step2.type === "stockingRate"
            ? store.state.step2.target
            : store.state.step2.stockingRateTarget
        )
      );
      store.state.step3.maintenanceFertiliserRate = parseFloat(rate.toFixed(2));
      return rate;
    },

    // kg fertiliser/ha/year results (exported)
    kgFertiliserResults: function(this:any) {
      let results = {
        maintenance: {
          start: { ha: 0, fertiliser: 0 },
          end: { ha: 0, fertiliser: 0 }
        },
        additional: {
          start: { ha: 0, fertiliser: 0 },
          end: { ha: 0, fertiliser: 0 }
        },
        total: {
          start: { ha: 0, fertiliser: 0 },
          end: { ha: 0, fertiliser: 0 }
        },
        average: {
          ha: 0,
          fertiliser: 0
        }
      };

      // Maintenance
      results.maintenance.start.ha = this.maintenanceP(this.stockingRateYr1);
      results.maintenance.end.ha = this.maintenanceP(
        store.state.step2.type === 'stockingRate'
        ? store.state.step2.target
        : store.state.step2.stockingRateTarget
      );
      results.maintenance.start.fertiliser = this.fertiliser(this.maintenanceP(this.stockingRateYr1));
      results.maintenance.end.fertiliser = this.maintenanceFertiliserRate;

      // Additional
      results.additional.start.ha = this.extraPRequired;
      results.additional.end.ha = this.extraPRequired;
      results.additional.start.fertiliser = this.fertiliser(this.extraPRequired);
      results.additional.end.fertiliser = this.fertiliser(this.extraPRequired);

      // Total
      results.total.start.ha = (this.maintenanceP(this.stockingRateYr1) + this.extraPRequired)
      results.total.end.ha = (
        (this.maintenanceP(
          store.state.step2.type === 'stockingRate'
          ? store.state.step2.target
          : store.state.step2.stockingRateTarget
        ) +
        this.extraPRequired)
      );
      results.total.start.fertiliser = (((this.maintenanceP(this.stockingRateYr1) + this.extraPRequired) / store.state.step3.concentration) * 100)
      results.total.end.fertiliser = (
        ((this.maintenanceP(store.state.step2.type === 'stockingRate' ? store.state.step2.target : store.state.step2.stockingRateTarget) +
        this.extraPRequired) /
        store.state.step3.concentration) *
        100
      );

      // Average
      results.average.ha = this.averageAnnual;
      results.average.fertiliser = this.fertiliserRate;

      store.state.step3.exportResults = results;
      return results
    }
  },

  methods: {
    // Calculate the maintenance P
    maintenanceP: (stockingRate: number): number => {
      return Math.floor(stockingRate * store.state.step3.DSE * 100) / 100;
    },

    // Calculate the fertiliser
    fertiliser: (maintenanceP: number): number => {
      if (store.state.step3.concentration > 0) {
        let fertiliser = (maintenanceP / store.state.step3.concentration) * 100;
        return fertiliser;
      }
      return 0;
    },

    // Returns the index of the pasture data based on selections in step A
    getPastureDataIndex: function(): number {
      let soilLoss = 0;
      let animalLoss = 0;
      let index = 0;
      // Soil Loss
      switch (store.state.step3.soilLoss) {
        case "Low":
          soilLoss += 1;
          break;
        case "Medium":
          soilLoss += 2;
          break;
        case "High":
          soilLoss += 3;
          break;
      }
      // Animal Loss
      switch (store.state.step3.slope) {
        case "Flat":
          animalLoss += 1;
          break;
        case "Easy":
          animalLoss += 2;
          break;
        case "Steep":
          animalLoss += 3;
          break;
      }
      switch (store.state.step3.grazing) {
        case "Intensive":
          animalLoss += 0;
          break;
        case "Set":
          animalLoss += 1;
          break;
      }
      index = 4 * (soilLoss - 1) + animalLoss - 1;
      return index;
    }
  },

  store
};
